export enum EthnicityEnum {
  NotLatin = 1,
  YesMexican = 2,
  YesPuertoRican = 3,
  YesCuban = 4,
  YesHispanic = 5,
  UnableToRespond = 6,
  DeclinesToRespond = 7
}

export const EthnicityOptions = [
{ id: 1, label: 'A. Not of Hispanic, Latino/a, or Spanish origin' },
{ id: 2, label: 'B. Mexican, Mexican American, Chicano/a' },
{ id: 3, label: 'C. Puerto Rican' },
{ id: 4, label: 'D. Cuban' },
{ id: 5, label: 'E. Another Hispanic, Latino, or Spanish origin' },
{ id: 6, label: 'X. Patient unable to responsd' },
{ id: 7, label: 'Y. Patient declines to respond' }
];
